// import Vue from 'vue';
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Popover,
  Tooltip,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Alert,
  Icon,
  Row,
  Col,
  Progress,
  Spinner,
  Card,
  Steps,
  Step,
  Collapse,
  CollapseItem,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Notification,
  Badge,
  Table,
  TableColumn,
  Timeline,
  TimelineItem,
  DatePicker,
  TimePicker,
  TimeSelect,
  Tree,
  InputNumber,
  Divider,
  Cascader,
  Upload,
  Transfer,
  Empty,
  Image,
  Scrollbar,
  Switch,
  InfiniteScroll,
  Breadcrumb,
  BreadcrumbItem,
  Rate,
  Autocomplete,
  Carousel,
  CarouselItem ,
  PageHeader
} from 'element-ui'

import retMessage from './retMessage'

const element = {
  install: function(Vue) {
    Vue.use(PageHeader)
    Vue.use(TimeSelect)
    Vue.use(Pagination)
    Vue.use(Dialog)
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(MenuItemGroup)
    Vue.use(Input)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Checkbox)
    Vue.use(CheckboxButton)
    Vue.use(CheckboxGroup)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(OptionGroup)
    Vue.use(Button)
    Vue.use(ButtonGroup)
    Vue.use(Popover)
    Vue.use(Tooltip)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Alert)
    Vue.use(Icon)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Progress)
    Vue.use(Spinner)
    Vue.use(Card)
    Vue.use(Steps)
    Vue.use(Step)
    Vue.use(Collapse)
    Vue.use(CollapseItem)
    Vue.use(Container)
    Vue.use(Header)
    Vue.use(Aside)
    Vue.use(Main)
    Vue.use(Footer)
    Vue.use(Badge)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Timeline)
    Vue.use(TimelineItem)
    Vue.use(DatePicker)
    Vue.use(TimePicker)
    Vue.use(Tree)
    Vue.use(InputNumber)
    Vue.use(Transfer)
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    Vue.use(Rate)
    

    Vue.use(Loading.directive)
    Vue.use(Divider)
    Vue.use(Cascader)
    Vue.use(Upload)
    Vue.use(Empty)
    Vue.use(Image)
    Vue.use(Scrollbar)
    Vue.use(Switch)
    Vue.use(InfiniteScroll)
    Vue.use(Autocomplete)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = retMessage
  },
}

export default element
